module.exports = __webpack_public_path__ + "img/jingshi_img.7f0eb1c6.png";